const flexiConfig = {
  items: [
    {
      name: "person_name",
      label: "Person's Name",
      type: "TextField",
    },
    {
      name: "states",
      label: "Person's State",
      type: "DropDown",
      values: ["Maharashtra", "Kerala", "Tamil Nadu"],
    },
  ],
};

export default flexiConfig;